import React, { useEffect } from 'react';

interface Props {
  open: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
  size?: 'sm' | 'md' | 'lg';
}

export function Modal({ open, onClose, title, children, footer, size = 'md' }: Props) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;
  const widthClass = size === 'sm' ? 'max-w-md' : size === 'lg' ? 'max-w-3xl' : 'max-w-xl';

  return (
    <div className="fixed inset-0 z-40 flex items-end sm:items-center justify-center p-0 sm:p-4">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose} />
      <div
        className={`relative ${widthClass} w-full max-h-[92vh] bg-surface-card border border-border rounded-t-2xl sm:rounded-2xl shadow-card animate-[fade_180ms_ease-out]`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-start justify-between p-5 border-b border-border">
          <h3 className="text-h4">{title}</h3>
          <button onClick={onClose} className="text-ink-muted hover:text-ink-primary text-h4 leading-none">
            ×
          </button>
        </div>
        <div className="p-4 sm:p-5 max-h-[68vh] overflow-auto">{children}</div>
        {footer && <div className="flex flex-wrap justify-end gap-2 p-4 sm:p-5 border-t border-border">{footer}</div>}
      </div>
    </div>
  );
}
